export default {
    'export': 'Exportar',
    'export-as-excel': 'Exportar a excel',
    'print-accounts-tree': 'Imprimir árbol de cuentas',
    'account-num-or-name': 'Número o nombre de la cuenta',
    add: 'Añadir',
    'please-select-account': 'Eleja cuenta ',
    'number-of-main-accounts': 'Conteo de cuentas principales:',
    'number-of-sub-accounts': 'Conteo de sub-cuentas:',
}